import React from 'react'
import { FieldError } from './CreateAccount'
import { SEND_PASSWORD_RESET_EMAIL } from 'requests'

export default class ForgotPasswordForm extends React.Component{
  state = {
    errors: {}
  }
  sendPasswordEmail = () => {
    SEND_PASSWORD_RESET_EMAIL({userId: this.email.value}, () => {
      this.props.returnAndDisplaySuccess()
    }, err => {
      console.error(err);
      this.setState(state => ({
        errors: {
          ...state.errors,
          submit: "Something went wrong, please try again later."
        }
      }))
    })
  }
  render(){
    const { returnToLogin } = this.props;
    return(
      <div className='login forgot-password'>
        <p className='description'>
          In order to change your password, please input the email associated with your account.
        </p>
        <div className="field">
          <label>Email</label>
          <input
            type="text"
            ref={ref => {
              this.email = ref
            }}
            onKeyDown={this.checkEnter}
            placeholder="example@email.com"
          />
          <FieldError>{this.state.errors.email}</FieldError>
        </div>
        <div className="button-wrapper create-wrapper">
          <button
            type="button"
            className="btn-raised btn-light-primary submit"
            onClick={this.sendPasswordEmail}
          >
            SUBMIT
          </button>
        </div>
        <div className="button-wrapper create-wrapper">
          <button
            type="button"
            className="create-account-button"
            onClick={returnToLogin}
          >
            Return to login
          </button>
        </div>
        <FieldError>{this.state.errors.submit}</FieldError>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shell/Login/ForgotPasswordForm.js